const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

// Handoff between the product form and the accessories page. The pending item is
// dropped after this long so a stale product can't be added days later.
const ACCESSORIES_STEP_KEY = 'accessories-step:pending-item';
const ACCESSORIES_STEP_MAX_AGE = 60 * 60 * 1000;
